// API 根地址
export const API_ROOT = process.env.REACT_APP_API_ROOT || ''

// 单个文件大小限制
export const MaxFileSizeInBytes =
  parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '0', 10) || 100 * 1024 * 1024
